<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <rect
            class="cls-1"
            x="0.75"
            y="0.75"
            width="22.5"
            height="22.5"
            rx="3"
            ry="3"
        />

        <path
            class="cls-1"
            d="M.75,8.25h6L7.915,5.921a.375.375,0,0,1,.67,0l2.352,4.7a.375.375,0,0,0,.661.019l2.351-4.115a.375.375,0,0,1,.638-.022L15.75,8.25h7.5"
        />

        <line class="cls-1" x1="5.25" y1="20.25" x2="5.25" y2="18.75" />

        <line class="cls-1" x1="14.25" y1="20.25" x2="14.25" y2="18.75" />

        <line class="cls-1" x1="9.75" y1="20.25" x2="9.75" y2="17.25" />

        <line class="cls-1" x1="18.75" y1="20.25" x2="18.75" y2="17.25" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'MonitorHeartRateIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.cls-1 {
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
